import axios from "./config";

/**
 * @function
 * @name getProcuringEntityContracts
 * @description get Procuring Entity Contracts
 * */
const getProcuringEntityContracts = (filter = {}) =>
  axios
    .get(`/procuring_entities_contracts`, { params: filter })
    .then((response) => response.data);

/**
 * @function
 * @name getProcuringEntityContract
 * @description get a specific Procuring Entity Contract
 * */
const getProcuringEntityContract = (id) =>
  axios
    .get(`/procuring_entities_contracts/${id}`)
    .then((response) => response.data);

/**
 * @function
 * @name createProcuringEntityContract
 * @description create a new Procuring Entity Contract
 * */
const createProcuringEntityContract = (data) =>
  axios
    .post(`/procuring_entities_contracts`, data)
    .then((response) => response.data);

/**
 * @function
 * @name updateProcuringEntityContract
 * @description update a Procuring Entity Contract
 * */
const updateProcuringEntityContract = (id, data) =>
  axios
    .put(`/procuring_entities_contracts/${id}`, data)
    .then((response) => response.data);

/**
 * @function
 * @name deleteProcuringEntityContract
 * @description delete a Procuring Entity Contract
 * */
const deleteProcuringEntityContract = (id) =>
  axios
    .delete(`/procuring_entities_contracts/${id}`)
    .then((response) => response.data);

export default {
  getProcuringEntityContracts,
  getProcuringEntityContract,
  createProcuringEntityContract,
  updateProcuringEntityContract,
  deleteProcuringEntityContract,
};
